module.exports = __webpack_public_path__ + "static/lunchtype23-regular-italic-webfont-3f33a83d778e70d166c1aaaab7bc29c9.ttf";